import { PathnameEnum, styleConstant, UserRoleEnum } from '@constant';
import { colorSet } from '@theme';
import { useLocation, useNavigate } from 'react-router';
import {
  Text,
  Accordion,
  AccordionExpandIcon,
  AccordionSummary,
  AccordionDetails,
  ListItemIcon,
  ListItemButton
} from '..';
import { List } from '@mui/material';
import { FlagGray600Icon, ListGray600Icon, ProfileGray600Icon, TrashCanGray600Icon } from '@assets/iconComponents';
import { useSelector } from '@stores';

export const AdminNavigation = () => {
  const userRole = useSelector((state) => state.auth.role);

  const navigate = useNavigate();
  const location = useLocation();
  const locationPathname = location.pathname;
  const isImageListPage = locationPathname.includes(PathnameEnum.ADMIN_IMAGE_LIST_ROOT);
  const isStandardImageListPage = locationPathname === PathnameEnum.ADMIN_STANDARD_IMAGE_LIST_PAGE;
  const isAdultsOnlyImageListPage = locationPathname === PathnameEnum.ADMIN_ADULTS_ONLY_IMAGE_LIST_PAGE;
  const isIssueReportList = locationPathname.includes(PathnameEnum.ADMIN_ISSUE_REPORT_LIST_ROOT);
  const isOpenIssueReportList = locationPathname === PathnameEnum.ADMIN_OPEN_ISSUE_REPORT_LIST;
  const isResolvedIssueReportList = locationPathname === PathnameEnum.ADMIN_RESOLVED_ISSUE_REPORT_LIST;
  const isDeletedImageListPage = locationPathname === PathnameEnum.ADMIN_DELETED_IMAGE_LIST_PAGE;
  const isUserPage = locationPathname.includes(PathnameEnum.ADMIN_USER_LIST_PAGE);

  const childMenuSpace = '52px'; //자식 메뉴 좌측 여백

  const handleMenuClick = (path: string) => {
    return navigate(path);
  };

  // 권한 체크 함수 - 루트관리자 또는 최고관리자만 회원관리 페이지들에 접근 가능하도록 함
  const canAccessUserManagement = () => {
    return userRole === UserRoleEnum['루트 관리자'] || userRole === UserRoleEnum['최고 관리자'];
  };

  return (
    <div
      style={{
        width: 240,
        minHeight: `calc(100vh - ${styleConstant.menuTopHeight}px)`,
        padding: '40px 20px',
        backgroundColor: colorSet.gray100,
        flexShrink: 0
      }}
    >
      <Accordion defaultExpanded={true}>
        <AccordionSummary expandIcon={<AccordionExpandIcon />}>
          <ListItemButton
            onClick={(e) => {
              e.stopPropagation();
              handleMenuClick(PathnameEnum.ADMIN_STANDARD_IMAGE_LIST_PAGE);
            }}
          >
            <ListItemIcon>
              <ListGray600Icon />
            </ListItemIcon>
            <Text variant="body1" fontWeight={isImageListPage ? 'bold' : 'normal'}>
              이미지 리스트
            </Text>
          </ListItemButton>
        </AccordionSummary>
        <AccordionDetails>
          <List component="div" disablePadding>
            <ListItemButton
              sx={{ ml: childMenuSpace }}
              onClick={() => {
                handleMenuClick(PathnameEnum.ADMIN_STANDARD_IMAGE_LIST_PAGE);
              }}
            >
              <Text variant="body1" fontWeight={isStandardImageListPage ? 'bold' : 'normal'}>
                - 스탠다드 검색
              </Text>
            </ListItemButton>
          </List>
          <List component="div" disablePadding>
            <ListItemButton
              sx={{ ml: childMenuSpace }}
              onClick={() => {
                handleMenuClick(PathnameEnum.ADMIN_ADULTS_ONLY_IMAGE_LIST_PAGE);
              }}
            >
              <Text variant="body1" fontWeight={isAdultsOnlyImageListPage ? 'bold' : 'normal'}>
                - 19금
              </Text>
            </ListItemButton>
          </List>
        </AccordionDetails>
      </Accordion>

      <Accordion defaultExpanded={true}>
        <AccordionSummary expandIcon={<AccordionExpandIcon />}>
          <ListItemButton
            onClick={(e) => {
              e.stopPropagation();
              handleMenuClick(PathnameEnum.ADMIN_OPEN_ISSUE_REPORT_LIST);
            }}
          >
            <ListItemIcon>
              <FlagGray600Icon />
            </ListItemIcon>
            <Text variant="body1" fontWeight={isIssueReportList ? 'bold' : 'normal'}>
              오류 리포트
            </Text>
          </ListItemButton>
        </AccordionSummary>
        <AccordionDetails>
          <List component="div" disablePadding>
            <ListItemButton
              sx={{ ml: childMenuSpace }}
              onClick={() => {
                handleMenuClick(PathnameEnum.ADMIN_OPEN_ISSUE_REPORT_LIST);
              }}
            >
              <Text variant="body1" fontWeight={isOpenIssueReportList ? 'bold' : 'normal'}>
                - 접수된 오류
              </Text>
            </ListItemButton>
          </List>
          <List component="div" disablePadding>
            <ListItemButton
              sx={{ ml: childMenuSpace }}
              onClick={() => {
                handleMenuClick(PathnameEnum.ADMIN_RESOLVED_ISSUE_REPORT_LIST);
              }}
            >
              <Text variant="body1" fontWeight={isResolvedIssueReportList ? 'bold' : 'normal'}>
                - 처리 완료
              </Text>
            </ListItemButton>
          </List>
        </AccordionDetails>
      </Accordion>

      <Accordion defaultExpanded={true}>
        <AccordionSummary expandIcon={<div style={{ width: 20, height: 16 }} />}>
          <ListItemButton
            onClick={(e) => {
              e.stopPropagation();
              handleMenuClick(PathnameEnum.ADMIN_DELETED_IMAGE_LIST_PAGE);
            }}
          >
            <ListItemIcon>
              <TrashCanGray600Icon />
            </ListItemIcon>
            <Text variant="body1" fontWeight={isDeletedImageListPage ? 'bold' : 'normal'}>
              삭제된 이미지
            </Text>
          </ListItemButton>
        </AccordionSummary>
      </Accordion>

      {canAccessUserManagement() && (
        <Accordion defaultExpanded={true}>
          <AccordionSummary expandIcon={<div style={{ width: 20, height: 16 }} />}>
            <ListItemButton
              onClick={(e) => {
                e.stopPropagation();
                handleMenuClick(PathnameEnum.ADMIN_USER_LIST_PAGE);
              }}
            >
              <ListItemIcon>
                <ProfileGray600Icon />
              </ListItemIcon>
              <Text variant="body1" fontWeight={isUserPage ? 'bold' : 'normal'}>
                회원 관리
              </Text>
            </ListItemButton>
          </AccordionSummary>
        </Accordion>
      )}
    </div>
  );
};
